import moment from 'moment/moment';

const CUSTOM_STAGE = 'Custom Stage';

const RESET_STAGE_SELECTION = {
  selectedStage: '',
  selectedStatus: '',
  selectedDate: '',
  customStageName: '',
  isCustomStageEnabled: false,
};

const toMoment = (date: any): Date =>
  new Date(moment(date).format('MM/DD/YYYY'));

const buildPendingStage = (formData: any): any | null => {
  if (!formData.selectedStage || !formData.selectedStatus) {
    return null;
  }

  const isCustomStage: boolean = formData.selectedStage === CUSTOM_STAGE;

  const customStageBase: any = {
    name: formData.customStageName,
    type: CUSTOM_STAGE,
    statusId: formData.selectedStatus,
  };

  const presetStageBase: any = {
    id: formData.selectedStage,
    statusId: formData.selectedStatus,
  };

  const base: any = isCustomStage ? customStageBase : presetStageBase;

  if (!formData.selectedDate) {
    return base;
  }

  return { ...base, date: toMoment(formData.selectedDate) };
};

const updateStageField = (stage: any, fieldName: string, value: any): any => {
  const isSavedCustomStageChangingValue: boolean =
    stage.type === CUSTOM_STAGE && stage.id && stage.id !== value;

  if (isSavedCustomStageChangingValue) {
    if (fieldName === 'name') {
      return { ...stage, name: value };
    }

    const convertedToPresetStage: any = {
      name: '',
      type: null,
      statusId: stage.statusId,
      id: value,
    };

    return convertedToPresetStage;
  }

  const isSwitchingToCustomStage: boolean = value === CUSTOM_STAGE;

  if (isSwitchingToCustomStage) {
    const freshCustomStage: any = {
      name: '',
      type: CUSTOM_STAGE,
      statusId: stage.statusId,
    };

    return freshCustomStage;
  }

  const isNamingCustomStage: boolean = fieldName === 'name';

  if (isNamingCustomStage) {
    return { ...stage, name: value, type: CUSTOM_STAGE };
  }

  const normalizedValue: any = fieldName === 'date' ? toMoment(value) : value;

  return { ...stage, [fieldName]: normalizedValue };
};

const mergePendingStage = (formData: any): any[] => {
  const pending: any | null = buildPendingStage(formData);

  if (!pending) {
    return formData.constructionStages;
  }

  return [...formData.constructionStages, pending];
};

const validatePropertyFields = (formData: any): any => {
  const errors: any = {};

  if (formData.name.trim().length === 0) {
    errors.errors = true;
    errors.name = 'Please Enter Property Name !';
  }

  if (formData.addressLine1.trim().length === 0) {
    errors.errors = true;
    errors.addressLine1 = 'Please Enter Address !';
  }

  if (formData.city.trim().length === 0) {
    errors.errors = true;
    errors.city = 'Please Enter City !';
  }

  if (formData.province.trim().length === 0) {
    errors.errors = true;
    errors.province = 'Please Enter Province !';
  }

  if (formData.postalCode.trim().length === 0) {
    errors.errors = true;
    errors.postalCode = 'Please Enter Postal Code !';
  }

  if (formData.postalCode.trim().length < 5) {
    errors.errors = true;
    errors.postalCode =
      'Please enter a valid postal code with min 5 characters !';
  }

  if (formData.postalCode.trim().length > 10) {
    errors.errors = true;
    errors.postalCode =
      'Please enter a valid postal code with max 10 characters !';
  }

  return errors;
};

export {
  validatePropertyFields,
  mergePendingStage,
  buildPendingStage,
  updateStageField,
  RESET_STAGE_SELECTION,
};
